import * as types from "../constants/actionTypes";

export const rateSelected = ({
  rateId,
  priceCode,
  planCode,
  allocationCode,
  roomId,
  RequestDescriptor,
  disableCartSlideOut
}) => {
  return {
    type: types.RATE_SELECTED,
    payload: {
      rateId,
      priceCode,
      planCode,
      roomId,
      allocationCode,
      RequestDescriptor,
      disableCartSlideOut
    }
  };
};

export const rateUnSelected = ({
  rateId,
  priceCode,
  planCode,
  allocationCode,
  roomId,
  RequestDescriptor,
  disableCartSlideOut
}) => {
  return {
    type: types.RATE_UNSELECTED,
    payload: {
      rateId,
      priceCode,
      planCode,
      allocationCode,
      roomId,
      RequestDescriptor,
      disableCartSlideOut
    }
  };
};

export const sortRatesByLowestPrice = () => {
  return {
    type: types.SORT_BY_LOWEST_PRICE
  };
};



// WEBPACK FOOTER //
// ./src/actions/ratesActions.js